export const links = [
    {
      name: "دسته بندی کالاها",
      submenu: true,
      
      sublinks: [
        {
          Head: "خودرو، ابزار و تجهیزات صنعتی",
          sublink: [
            { name: "خودرو های ایرانی", link: "/" },
            { name: "موتور سیکلت", link: "/" },
            { name: "لوازم جانبی خودرو و موتورسیکلت", link: "/" },
            { name: "لوازم یدکی خودرو و موتورسیکلت", link: "/" },
            { name: "ابزار برقی", link: "/" },
            { name: "ابزار غیر برقی", link: "/" },
            { name: "لوازم و یراق آلات ساختمانی", link: "/" },
            { name: "لوازم باغبانی", link: "/" },
            { name: "نور و روشنایی", link: "/" },
          ],
        },
        {
          Head: "کالای دیجیتال",
          sublink: [
            { name: "لوازم جانبی گوشی", link: "/" },
            { name: "گوشی موبایل", link: "/" },
            { name: "تبلت", link: "/" },
            { name: "مچ بند و ساعت هوشمند", link: "/" },
            { name: "هدفون,هدست ,هندسفری", link: "/" },
            { name: "اسپیکر بلوتوث و با سیم", link: "/" },
            { name: "هارد, فلش ", link: "/" },
            { name: "دوربین", link: "/" },
            { name: "تلسکوپ", link: "/" },
            { name: "لپتاپ", link: "/" },
          ],
        },
        {
          Head: "مد و پوشاک",
          sublink: [
            { name: "مردانه", link: "/" },
            { name: "لباس مردانه", link: "/" },
            { name: "کفش مردانه", link: "/" },
            { name: "زنانه", link: "/" },
            { name: "لباس زنانه", link: "/" },
            { name: "کفش زنانه", link: "/" },
            { name: "یورآلات زنانه", link: "/" },
            { name: "بچه گانه", link: "/" },
            { name: "پوشاک ورزشی پسرانه", link: "/" },
            { name: "کفش ورزشی زنانه", link: "/" },
          ],
        },
  
        {
          Head: "کالاهای سوپرمارکتی",
          sublink: [
            { name: "کالای اساسی و خوار و بار", link: "/" },
            { name: "صبحانه", link: "/" },
            { name: "مواد پروتئینی", link: "/" },
            { name: "لبنیات", link: "/" },
            { name: "نوشیدنی ها", link: "/" },
            { name: "میوه و سبزی", link: "/" },
            { name: "غذای آماده و نودل", link: "/" },
            { name: "تنقلات", link: "/" },
            { name: "خشکبار و شیرینی", link: "/" },
            { name: "فراورده های منجمد", link: "/" },
          ],
        },
        {
          Head: "اسباب بازی، کودک و نوزاد",
          sublink: [
            { name: "بهداشت و حمام کودک و نوزاد", link: "/" },
            { name: "پوشاک و کفش کودک و نوزاد", link: "/" },
            { name: "اسباب بازی", link: "/" },
            { name: "بازی و سرگرمی کودک", link: "/" },
            { name: "سلامت، ایمنی و مراقبت", link: "/" },
            { name: "خواب کودک", link: "/" },
            { name: "ملزومات گردش و سفر", link: "/" },
            { name: "لوازم شخصی", link: "/" },
            { name: "غذاخوری", link: "/" },
            { name: "تبلت", link: "/" },
          ],
        },
        
        {
          Head: "محصولات بومی و محلی",
          sublink: [
            { name: "خوراکی‌های بومی محلی", link: "/" },
            { name: "ظروف سنتی", link: "/" },
            { name: "ابزار آشپزخانه سنتی", link: "/" },
            { name: "دکوراتیو سنتی", link: "/" },
            { name: "خواب و حمام", link: "/" },
            { name: "انواع قالی و قالیچه", link: "/" },
            { name: "پوشیدنی‌های بومی محلی", link: "/" },
            { name: "زهرمار", link: "/" },
            { name: "زهرمار2", link: "/" },
            { name: "زهرمار3", link: "/" },
          ],
        },
        {
          Head: "زیبایی و سلامت",
          sublink: [
            { name: "لوازم آرایشی", link: "/" },
            { name: "لوازم بهداشتی", link: "/" },
            { name: "لوازم شخصی برقی", link: "/" },
            { name: "عطر، ادکلن، اسپری و ست", link: "/" },
            { name: "طلا، نقره و زیورآلات زنانه", link: "/" },
            { name: "ابزار سلامت و طبی", link: "/" },
            { name: "دسبند طلا", link: "/" },
            { name: "گردنبند", link: "/" },
            { name: "گوشواره", link: "/" },
            { name: "حلقه", link: "/" },
          ],
        },
        {
          Head: "خانه و آشپزخانه",
          sublink: [
            { name: "صوتی و تصویری", link: "/" },
            { name: "دکوراتیو", link: "/" },
            { name: "لوازم برقی خانگی", link: "/" },
            { name: "مواد شوینده", link: "/" },
            { name: "سرو و پذیرایی", link: "/" },
            { name: "حیوانات خانگی، غذا و لوازم", link: "/" },
            { name: "دستمال کاغذی", link: "/" },
            { name: "حوله و وسبله حمام", link: "/" },
            { name: "کمد, پادری ,لوازم اتاق خواب", link: "/" },
            { name: "لوازم باغبانی", link: "/" },
          ],
        }
      ],
    } 
  ];